/**
 * 选择成人就餐人数
 */
import React, { createRef, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@cps'
import { classNames } from '@dt/fe-utils'
import './index.scss'
import { isNaN } from '@dt/fe-utils/dist/lodash'

interface IProps {
  personNum: number;
  hasKids: boolean;
  handle: (type: string, value: number) => void;
}

const SelectPerson: React.FC<IProps> = ({ personNum = 1, hasKids = false, handle }) => {
  const max = 9 // 最大数量
  const inputRef = createRef<any>()
  const [isInput, setInput] = useState<boolean>(false)
  const [inputValue, setInputValue] = useState<any>('')
  const personOptions = new Array(max).fill('')
  const handleSelect = (value: number) => {
    handle('person', value)
    setInput(false)
  }
  const handleInputStart = () => {
    setInput(true)
  }
  const handleBlur = (event) => {
    const value = parseInt(event.target.value)
    !isNaN(value) && handleSelect(value)
    !(value > max) && setInputValue('')
    setInput(false)
  }
  const handleInput = (event) => {
    const cnt = event.target.value
    setInputValue(cnt > 99 ? 99 : cnt)
  }
  useEffect(() => {
    setInputValue(personNum > max ? personNum : '')
  }, [personNum])
  return (
    <div className='select-person-container'>
      {hasKids && (
        <div className='select-icon-wrap'>
          <Icon name='jiucanrenshu' />
        </div>
      )}
      <div className='select-person-wrapper'>
        {
          personOptions.map((key, index) => (
            <div
              className={classNames('item', { active: !(isInput || personNum > max) && (personNum === index + 1) })}
              onClick={() => handleSelect(index + 1)}
              key={index}
            >
              {index + 1}
            </div>
          ))
        }
        <div className={classNames('item', { active: isInput || personNum > max })} onClick={handleInputStart}>
          <input className={classNames('input', { block: isInput })} ref={inputRef} value={inputValue} onInput={handleInput} onBlur={handleBlur} />
          {
            !isInput && (personNum > 9 ? null : <Icon name='shenglvehao' />)
          }
        </div>
      </div>
    </div>
  )
}

export default observer(SelectPerson)
